export default "__VITE_ASSET__Cb3N0CNU__"